// File: ConvertPartnershipIntoLLP.jsx
import React from "react";

export default function ConvertPartnershipIntoLLP() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Convert Partnership into LLP Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Professional Compliance Support by Hawkins &amp; Brooks
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists in conversion of partnership firms into LLPs.
          </p>
          <p className="text-gray-700">
            Complete conversion process including Form 17 filing, Form 2 incorporation, LLP Agreement execution, Registrar of Firms notification, and seamless transition maintaining business continuity with limited liability protection.
          </p>
        </div>

        {/* Right: Image (TOPIC-SPECIFIC: Partnership to LLP conversion) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/3184436/pexels-photo-3184436.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Partnership to LLP conversion process"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks ensures complete documentation for seamless partnership to LLP conversion.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Partnership deed and registration certificate</li>
                <li>Financial statements (last 2 years)</li>
                <li>Consent of all partners for conversion</li>
                <li>Proof of capital contribution proportions</li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              Smooth conversion handling ensuring limited liability benefits and business continuity.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Form 17 Conversion Perfection
                </h3>
                <p className="text-gray-700 text-sm">
                  Expert Form 17 application with partnership details, partner consent verification, capital proportion matching, DSC/DPIN compliance, MCA name reservation (RUN-LLP), and Form 2 incorporation ensuring 100% approval within 15-20 working days.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Seamless Business Transition
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete post-conversion execution including Form 3 LLP Agreement filing (within 30 days), PAN/TAN transfer, GST registration updation, bank account conversion, license/permit transfers, Registrar of Firms notification (Form 14 within 15 days), and zero business interruption.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Limited Liability Implementation
                </h3>
                <p className="text-gray-700 text-sm">
                  Full LLP benefits activation with perpetual succession, separate legal entity status, limited partner liability, simplified compliance (Form 8/11), audit exemption (less than Rs. 40 lakhs turnover), professional tax optimization, enhanced credibility for contracts/funding, and corporate governance structure.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}